import * as React from 'react';
import { colors } from '../../config';

interface ILineProps {
  width: number;
  plain?: boolean;
  className?: string;
  fill?: string;
  height?: number;
  opacity?: number;
  style?: object;
}

export const Line: React.SFC<ILineProps> = ({
  className,
  fill,
  height,
  opacity,
  plain,
  style,
  width,
}) => {
  return (
    <svg className={className} style={{ ...style, height, opacity, width }}>
      <line
        y1='100%'
        stroke-linecap='butt'
        stroke={fill && colors[fill]}
        stroke-width='4'
        stroke-dasharray={plain ? '' : '10, 10'}
      />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Line.tsx